import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Navbar from "../components/Navbar";
import api, { formatApiErrorDetail } from "../api/client";

const statusLabel = {
    initiated: "Open",
    signed: "Signed",
    paid: "Paid",
    transfer_complete: "Owned",
};

export default function MyDeals() {
    const [deals, setDeals] = useState([]);
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/deals");
                setDeals(data);
            } catch (e) {
                setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    return (
        <div className="min-h-screen bg-ink-300 text-silver-100">
            <Navbar />
            <div className="max-w-[1300px] mx-auto px-6 md:px-10 py-16">
                <div className="mb-10">
                    <div className="text-[11px] tracking-[0.3em] uppercase text-platinum mb-2">
                        Buyer desk
                    </div>
                    <h1 className="font-display text-5xl">My deals</h1>
                </div>

                {err && <div className="text-red-400 text-sm mb-4">{err}</div>}

                {loading ? (
                    <div className="text-silver-500 animate-pulse">Loading…</div>
                ) : deals.length === 0 ? (
                    <div className="glass p-10 text-center rounded-sm">
                        No deals yet. <Link to="/catalog" className="text-platinum">Browse the catalog</Link>.
                    </div>
                ) : (
                    <div className="space-y-3">
                        {deals.map((d, i) => (
                            <motion.div
                                key={d.id}
                                initial={{ opacity: 0, y: 12 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: i * 0.04 }}
                                className="glass p-4 md:p-5 rounded-sm flex items-center gap-5"
                            >
                                {d.film_poster && (
                                    <img src={d.film_poster} alt={d.film_title} className="w-14 h-20 object-cover rounded-sm border border-white/10" />
                                )}
                                <div className="flex-1 min-w-0">
                                    <div className="font-display text-xl truncate">{d.film_title}</div>
                                    <div className="text-xs text-silver-500 mt-1 uppercase tracking-widest">
                                        Deal · ${Number(d.price_usd).toLocaleString()} · {statusLabel[d.status] || d.status}
                                    </div>
                                </div>
                                <Link
                                    to={d.status === "transfer_complete" ? `/vault/${d.id}` : `/deal/${d.id}`}
                                    className="text-xs bg-platinum text-ink-300 px-4 py-2 rounded-sm uppercase tracking-widest"
                                    data-testid={`open-deal-${d.id}`}
                                >
                                    {d.status === "transfer_complete" ? "Vault" : "Open"}
                                </Link>
                            </motion.div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
